"use client";

import { useLanguage } from "@/i18n/LanguageContext";

export default function HeroSection() {
  const { t, currentLang } = useLanguage();

  const heroImageSrc = currentLang === "es"
    ? "https://storage.readdy-site.link/project_files/76915537-ee3f-4564-9a23-41bd98b5df27/1bf1103f-6709-4c98-8c3c-acfcd699370c_Sliding-Door-Repair-Miami.jpg?v=caaec9e497d3fecc922adf6b92ec183e"
    : "https://storage.readdy-site.link/project_files/76915537-ee3f-4564-9a23-41bd98b5df27/1bf1103f-6709-4c98-8c3c-acfcd699370c_Sliding-Door-Repair-Miami.jpg?v=caaec9e497d3fecc922adf6b92ec183e";

  return (
    <section className="bg-[#fefce8] py-16 px-4 md:px-6">
      <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
        <div className="flex-1 space-y-6">
          <h1 className="text-3xl md:text-[42px] font-bold text-[#064e3b] leading-tight">
            {t("sliding.h1")}
          </h1>
          <p className="text-base md:text-lg text-gray-600 max-w-xl">
            {t("sliding.subhead")}
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <a
              href="tel:+17863774452"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-[#ea580c] hover:bg-[#ea580c]/90 text-white font-semibold rounded-md transition-colors whitespace-nowrap"
            >
              <i className="ri-phone-line" />
              {t("sliding.heroCallBtn")}
            </a>
            <a
              href="/contact"
              className="inline-flex items-center justify-center px-6 py-3 border-2 border-[#064e3b] text-[#064e3b] font-semibold rounded-md hover:bg-[#064e3b] hover:text-white transition-colors whitespace-nowrap"
            >
              {t("common.phoneQuote")}
            </a>
          </div>
        </div>
        <div className="flex-1 flex justify-center lg:justify-end">
          <img
            src={heroImageSrc}
            alt={t("sliding.heroImageAlt") as string}
            className="rounded-xl w-full max-w-[520px] h-auto object-cover"
          />
        </div>
      </div>
    </section>
  );
}